import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { EsnBackgroundGlowState } from '../../../shared/types/shell';

let nextId = 0;

/**
 * The page field behind the app frame: a violet bloom texture in dark, soft violet washes in
 * light. It follows the theme by itself and is purely decorative; page content is projected on top.
 */
@Component({
  selector: 'esn-background-glow',
  templateUrl: './background-glow.component.html',
  styleUrl: './background-glow.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': '"esn-background-glow--" + state()' },
})
export class BackgroundGlowComponent {
  /**
   * `auto` follows `[data-theme]`; `dark` / `light` pin one Figma state.
   */
  readonly state = input<EsnBackgroundGlowState>('auto');

  // SVG ids are document-global, so each instance gets its own filter/gradient ids.
  protected readonly uid = `esn-glow-${nextId++}`;
}
